module.exports = __webpack_public_path__ + "static/media/logo-black-green.cf4aa765.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/logo-black-green.png
// module id = 1259
// module chunks = 270